"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINTS = void 0;
/**
 * All breakpoints LMDS uses currently.
 */
var BREAKPOINTS = ['base', 'sm', 'md', 'lg', 'xl'];
exports.BREAKPOINTS = BREAKPOINTS;